import React from 'react';
import CalendarMonth from './CalendarMonth';
import chunk from 'lodash/chunk';
import { eachDay, addMonths, startOfMonth } from 'date-fns';

const translations = {
  availability: {
    pl: 'Dostępność',
    en: 'Availability',
    no: 'Tilgjengelighet',
  },
  back: {
    pl: 'Wstecz',
    en: 'Back',
    no: 'Tilbake',
  },
  further: {
    pl: 'Dalej',
    en: 'Further',
    no: 'Lengre',
  },
};

const getMonthDates = () => {
  const dateToday = new Date();
  const startOfCurrentMonth = startOfMonth(dateToday);
  let monthDates = [];

  for (let i = 0; i < 15; i++) {
    monthDates.push(addMonths(startOfCurrentMonth, i));
  }

  return monthDates;
};

class YearCalendar extends React.Component {
  state = {
    currentCalendarTab: 0,
  };

  getGroupedDates = () => {
    const stays = JSON.parse(this.props.stays);
    return stays.map(stay => eachDay(new Date(stay.arrival), new Date(stay.departure)));
  };

  handleOnBackClick = ev => {
    ev.preventDefault();

    this.setState(state => ({
      ...state,
      currentCalendarTab: state.currentCalendarTab - 1,
    }));
  };

  handleOnFurtherClick = ev => {
    ev.preventDefault();

    this.setState(state => ({
      ...state,
      currentCalendarTab: state.currentCalendarTab + 1,
    }));
  };

  render() {
    const { lang } = this.props;
    const { currentCalendarTab } = this.state;
    const monthDatesChunks = chunk(getMonthDates(), 6);

    if (!this.props.stays) {
      return null;
    }

    return (
      <div className="year-calendar">
        <div className="uk-card uk-card-default uk-width-1-1">
          <div className="uk-card-header">
            <h3 className="uk-card-title">{translations.availability[lang]}</h3>
          </div>
          <div className="uk-card-body">
            <div className="nav">
              <div className="button-container">
                <button
                  className="uk-button uk-button-default"
                  onClick={this.handleOnBackClick}
                  disabled={currentCalendarTab <= 0}
                >
                  {translations.back[lang]}
                </button>
              </div>
              <div className="button-container">
                <button
                  className="uk-button uk-button-default"
                  onClick={this.handleOnFurtherClick}
                  disabled={currentCalendarTab >= 2}
                >
                  {translations.further[lang]}
                </button>
              </div>
            </div>
            {monthDatesChunks.map((monthDatesChunk, index) => {
              if (currentCalendarTab !== index) {
                return null;
              }

              return (
                <div key={monthDatesChunk[0]} className="months-container">
                  {monthDatesChunk.map(monthDate => (
                    <div key={monthDate} className="month-container">
                      <CalendarMonth key={monthDate} dates={this.getGroupedDates()} month={monthDate} />
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default YearCalendar;
